import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Loading from 'components/Loading';
import EstimatorDetailsCard from './components/estimatorDetailsCard';
import PayRateHistory from 'components/PayRateHistory';
import { requestEstimator, showHistoryScreen, requestPayRatesList,
         hideHistoryScreen, requestPTOList, requestAllStores,
         requestWorkroomList } from 'actionCreators';
import { getEstimatorById, getRole, getWorkroomById, getPayRateShowHistory, getStoreList,
         getPayRateCurrentName, getPayRateLoading, getPayRateCurrentHistoryList } from '../../../../reducers';
import connectUI from 'redux-ui';
import MessageBox from 'components/MessageBox';
import PTOType from 'types/pto';
import { can } from '../../../../services';
import { RoleType } from 'types/user';

class EstimatorDetails extends Component {
  componentDidMount = () => {
    const { dispatch, id } = this.props;
    dispatch(requestAllStores());
    dispatch(requestWorkroomList());
    dispatch(requestEstimator(id));
    dispatch(requestPTOList(id, 'estimators'));
  }

  componentWillUnmount = () => (this.props.ui.successMessage ? this.props.updateUI('successMessage', '') : null);

  handleTabChange = index => this.props.updateUI('activeTab', index);

  closeHistory = () => this.props.dispatch(hideHistoryScreen());

  showRateHistory = (rate) => {
    const { id, dispatch } = this.props;
    Promise.all([
      dispatch(showHistoryScreen(rate)),
      dispatch(requestPayRatesList(id, rate)),
    ]);
  }

  closeRateHistory = () => this.props.dispatch(hideHistoryScreen());

  estimatorCanView = () => {
    const { role, user: { employable_id = null } } = this.props;
    const regex = /estimators\/(\d+)/g;
    const match = regex.exec(window.location.href) || null;
    return can(role, 'view', 'estimator_details', { matching: parseInt(match[1], 10) === employable_id });
  };

  render = () => {
    const { estimator, loading, ui, role, workrooms, showHistory, rateName,
            loadingRateHistory, payRates, ptos, user, allStores } = this.props;
    return (<div>
      {role !== 'estimator' || this.estimatorCanView() ? (<Fragment>
        {ui.successMessage ? <MessageBox message={ui.successMessage} /> : null}
        {loading ? <Loading /> : <EstimatorDetailsCard
          activeTab={ui.activeTab}
          onTabChange={this.handleTabChange}
          estimator={estimator}
          workrooms={workrooms}
          allStores={allStores}
          role={role}
          handleRateHistory={this.showRateHistory}
          ptos={ptos}
          user={user}
        />}
        <PayRateHistory
          showHistory={showHistory}
          rateName={rateName}
          closeHistory={this.closeRateHistory}
          loading={loadingRateHistory}
          payRates={payRates}
        />
      </Fragment>) : <MessageBox message="You do not have permission to view this page." />}
    </div>);
  }
}

EstimatorDetails.propTypes = {
  allStores: PropTypes.array,
  id: PropTypes.number,
  estimator: PropTypes.object,
  workrooms: PropTypes.array,
  loading: PropTypes.bool,
  role: PropTypes.string,
  dispatch: PropTypes.func,
  updateUI: PropTypes.func,
  showHistory: PropTypes.bool,
  loadingRateHistory: PropTypes.bool,
  rateName: PropTypes.string,
  payRates: PropTypes.array,
  ui: PropTypes.object,
  ptos: PropTypes.arrayOf(PTOType),
  user: RoleType,
  requestAllStores: PropTypes.func,
  requestWorkroomList: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => {
  const id = Number(ownProps.params.id);
  const estimator = getEstimatorById(state)(id);
  return {
    id,
    estimator,
    workrooms: estimator && estimator.workrooms ?
      estimator.workrooms.map(wrId => getWorkroomById(state)(wrId)) : [],
    allStores: getStoreList(state),
    loading: estimator ? estimator.loading : true,
    showHistory: getPayRateShowHistory(state),
    loadingRateHistory: getPayRateLoading(state),
    rateName: getPayRateCurrentName(state),
    payRates: getPayRateCurrentHistoryList(state),
    role: getRole(state),
    ptos: state.ptos.data,
    user: state.user,
  };
};

export default connectUI()(connect(mapStateToProps, {
  requestAllStores, requestWorkroomList,
})(EstimatorDetails));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/estimators/estimatorDetails.jsx